<template>
  <ul>
    <li>
      <a href="https://github.com/censor-ed/censored/commits/gh-pages">更新履歴</a>
    </li>
    <li>
      <a href="https://censor-ed.github.io/censored/presets.json">JSON(すべて)</a>
    </li>
    <li>
      <a href="https://censor-ed.github.io/censored/important.json">JSON(重要)</a>
    </li>
  </ul>
</template>
